export default __webpack_public_path__ + "static/interact_logo-30a0409042af724e9b1daf457e5c92d9.svg";